// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom-image-container{overflow:hidden;height:100%;display:flex;align-items:center;justify-content:center;width:100%}.zoom-image-container img{will-change:transform}.zoom-image-container img.zoom-image{cursor:zoom-in}.zoom-image-container img.zoom-image.zoom-out{cursor:zoom-out}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
